import React, { useState, useEffect } from 'react';
import Spinner from '../../Components/Spinner/Spinner';
import {
	handleCollegeMultiDateBookings,
	filterByDateRangeOrSpecificDate,
	getRefId,
} from './Helper';
import { API } from '../../API';
import { teacherResponse, teacherStatus } from '../../Helper';
import BookingCardCollege from '../../Components/BookingCard/BookingCardCollege';
import { notify } from 'react-notify-toast';
import moment from "moment";
import JumpToTopButton from "../../Components/Buttons/JumpToTopButton";
import CollegeJobListSearchBar from './CollegeJobListSearchBar';
import { TablePagination } from '@mui/material';

const CollegeJobListMain = (props) => {
	let [isLoaded, setIsLoaded] = useState(false);
	let [allBookings, setAllBookings] = useState([]);
	let [allTeachers, setAllTeachers] = useState([]);
	let [showCurrentBookings, setShowCurrentBookings] = useState([]);
	let [refs, setRefs] = useState({});
	let [cancelSingleDay, setCancelSingleDay] = useState(false)
	let [showSingleBooking, setShowSingleBooking] = useState(true)
	const [rowsPerPage, setRowsPerPage] = useState(10)
	const [searchFilter, setSearchFilter] = useState({
		teacher_name: null,
		class_level_ids: [],
		class_level_names: [],
		locations: [],
		date_range: null,
		search_date: null
	})
	const [paginationInfo, setPaginationInfo] = useState({
		limit: 10,
		page: 1,
		total_page: null,
		total_record: null
	})
	const [bookingID, setBookingID] = useState(null)
	const [dateIndex, setDateIndex] = useState(null)
	const [qualifications, setQualifications] = useState([])

	useEffect(async () => {

		// Search filter
		let currentFilter = {
			teacher_name: null,
			class_level_ids: [],
			class_level_names: [],
			locations: [],
			date_range: null,
			search_date: null,
			booking_id: null
		}
		const strSearch = window.localStorage.getItem('searchBookingByCollegeFilter')
		
		if (strSearch) {
			currentFilter = JSON.parse(strSearch)
		}

		// booking
		const dateIndexData = getDateIndex();
		const bookingIDData = getBookingID();
		const resultTeacher = await API.getAllTeachersBrief()
		const teachers = resultTeacher?.data
		setAllTeachers( teachers || []);

		if(dateIndexData) {
			// check later
			setShowSingleBooking(true)
			setBookingID(bookingIDData)
			setDateIndex(dateIndexData)
			getAllBookingsWithFilter(currentFilter, teachers, rowsPerPage, paginationInfo.page, bookingIDData, dateIndexData)
		}
		else if (bookingIDData) {
			// check later
			setShowSingleBooking(true)
			setBookingID(bookingIDData)
			getAllBookingsWithFilter(currentFilter, teachers, rowsPerPage, paginationInfo.page, bookingIDData)
		}
		else {
			getAllBookingsWithFilter(currentFilter, teachers)
			setShowSingleBooking(false)
		}

		API.getQualificationList()
			.then((res) => {
				setQualifications(res?.data?.data || [])
			})
			.catch((error) => {
				console.log(('error get qualifications list', error))
			})

	}, []);

	const getDateIndex = () => {
		let pathname = window.location.href;
		let urlArray = pathname.split("#");
		const dateIndexData = urlArray[1]?.split("_")[1];
		if (dateIndexData === undefined) {
			// setShowFilter(true)
			setCancelSingleDay(false)
		}
		else {
			setCancelSingleDay(true)
		}
		return dateIndexData
	}

	const getBookingID = () => {
		let pathname = window.location.href;
		let urlArray = pathname.split("#");
		const bookingIDData = urlArray[1]?.split("_")[0];
		return bookingIDData
	}

	const getAllBookingsWithFilter = (currentFilterData, teachers, limit, page, bookingIDData = null, dateIndexData = null) => {
		setIsLoaded(false);
		let currentFilter = {
			...currentFilterData,
			class_level_names: currentFilterData?.class_level_names?.map(e => e?.split("_id:")?.[0]) || []
		}
		if(bookingIDData) {
			currentFilter = {
				teacher_name: null,
				class_level_ids: [],
				class_level_names: [],
				locations: [],
				date_range: null,
				search_date: null,
				booking_id: null
			}
		}
		
		API.getBookingListWithFilterAndPaginationV2(
			props.institution._id, 
			currentFilter, 
			{page: page || 1, limit: limit || rowsPerPage},
			bookingIDData || bookingID
		).then((result) => {
			let list = handleCollegeMultiDateBookings(result?.data?.data || []);
			list = handleTeacherForBookings([...list], teachers)
			if(currentFilter.date_range || currentFilter.search_date || dateIndexData) {
				if(dateIndexData !== null && list?.length) {
					if(list?.[0]?.dates?.[dateIndexData]?.date) {
						list = filterByDateRangeOrSpecificDate(
							list, 
							moment(list?.[0]?.dates?.[dateIndexData]?.date, "YYYY-MM-DD").format("DD-MM-YYYY")
						);
					} else {
						list = []
					}
				}
				else {
					list = filterByDateRangeOrSpecificDate(
						list, 
						currentFilter.date_range || currentFilter.search_date
					);
				}
			}
			handleBookingRefs(list)
			setAllBookings(list);
			setPaginationInfo(result?.data?.paginate)
			setIsLoaded(true);
			setShowCurrentBookings(list);
			setSearchFilter(currentFilter)
			setIsLoaded(true);
		})
	};

	const handleTeacherForBookings = (list, teachers) => {
		const newList = list.map(job => {
			let newJob = { ...job };
			if (
				job.teacher_id &&
				job.teacher_response === teacherResponse.accepted
			) {
				newJob.teacher = teachers.find(
					(teacher) => teacher._id === job.teacher_id
				);
			} else if (
				job.preferred_teacher &&
				job.teacher_response !== teacherResponse.rejected
			) {
				newJob.teacher = teachers.find(
					(teacher) => teacher._id === job.preferred_teacher
				);
			} else if (
				job.teacher_id &&
				job.teacher_status === teacherStatus.assigned
			) {
				newJob.teacher_assigned = teachers.find(
					(teacher) => teacher._id === job.teacher_id
				)
			} else {
				newJob.teacher = {};
			}
			return newJob;
		})
		return newList
	}

	const handleBookingRefs = (list) => {
		let allRefs = { ...refs };
		list.forEach((booking) => {
			allRefs[getRefId(booking)] = React.createRef();
		});
		setRefs(allRefs);
	}

	const confirmBookingCancel = (booking, inst_cancelled_reason, wages_percent, dateIndex, selectedDate) => {
		// console.log(booking, inst_cancelled_reason)
		let admin_fee = 0
		let teacherAllocated = booking.teacher && booking.teacher._id && booking.teacher_response === 'accepted';

		if (inst_cancelled_reason !== "Public holiday" && teacherAllocated) {
			admin_fee = 50
		}
		if (booking.multiple_date) {
			if (dateIndex) {
				API.splitBookingForCancelSingleDate(booking._id, dateIndex).then((res) => {
					const newBooking = res?.data?.data
					// find splitIndex because the booking already changed
					const splitIndex = newBooking.splits.findIndex(item =>
						item.date_from === selectedDate.date &&
						item.date_to === selectedDate.date
					)

					API.cancelMultiDateBooking(booking._id, splitIndex, inst_cancelled_reason, wages_percent, admin_fee)
						.then((res) => {
							notify.show('Booking cancelled successfully');
							// window.location.reload()
							getAllBookingsWithFilter(searchFilter, allTeachers, rowsPerPage, paginationInfo.page, bookingID, dateIndex)
						})
						.catch((err) => {
							console.log(err);
							notify.show(err?.response?.data?.message || 'Error cancelling booking');
						});
				}).catch((err) => {
					console.log(err);
				})
			}
			else {
				API.cancelMultiDateBooking(booking._id, booking.split_index, inst_cancelled_reason, wages_percent, admin_fee)
					.then((res) => {
						notify.show('Booking cancelled successfully');
						// window.location.reload()
						getAllBookingsWithFilter(searchFilter, allTeachers, rowsPerPage, paginationInfo.page, bookingID, dateIndex)
					})
					.catch((err) => {
						console.log(err);
						notify.show(err?.response?.data?.message || 'Error cancelling booking');
					});
			}

		}
		else {
			API.cancelBooking(booking._id, wages_percent, admin_fee)
				.then(() => {
					notify.show('Booking cancelled successfully');
					getAllBookingsWithFilter(searchFilter, allTeachers, rowsPerPage, paginationInfo.page, bookingID, dateIndex)
				})
				.catch((err) => {
					console.log(err);
					notify.show('Error cancelling booking');
				});
		}
	};

	const confirmChangeLevel = (booking, updated_level, updatedLevelID) => {
		API.collegeUpdateBookingLevel(booking._id, updated_level, updatedLevelID)
			.then(() => {
				getAllBookingsWithFilter(searchFilter, allTeachers, rowsPerPage, paginationInfo.page)
				notify.show('Booking level updated successfully');
			}).catch((err) => {
				console.log(err);
				notify.show('Error updating level');
			})
	}

	const onSearchBooking = (filter, limit, page) => {
		getAllBookingsWithFilter(filter, allTeachers, limit, page)
	}

	const handleChangeRowsPerPage = (value) => {
    setRowsPerPage(value)
    onSearchBooking(searchFilter, value)
  }

	const onPageNumChange = (e, value = 0) => {
    onSearchBooking(searchFilter, rowsPerPage, value + 1)
  };

	return (
		<div className='search-teacher-container justify-contents-between'>
			<div>
				{!showSingleBooking && <CollegeJobListSearchBar
					onSearchBooking={(filter) => onSearchBooking(filter, rowsPerPage)}
					user={props.user}
				/>}
			</div>

			<div className='search-teacher-main'>
			{showCurrentBookings.length && isLoaded && !showSingleBooking ? (
					<div>
						<TablePagination
							component="div"
							count={paginationInfo?.total_record}
							page={paginationInfo.page - 1}
							onPageChange={(e, page) => onPageNumChange(e, page)}
							rowsPerPage={rowsPerPage}
							rowsPerPageOptions={[10, 25, 50]}
							size="large"
							onRowsPerPageChange={(e) => handleChangeRowsPerPage(e.target.value)}
							showFirstButton
							showLastButton
						/>
					</div>
          ) : null}

				<div className='d-flex flex-wrap justify-content-center'>
					{isLoaded ? (
						showCurrentBookings.length ? (
							showCurrentBookings.map((job, index) => {
								const jobCampus = props.campuses.find(
									(campus) => campus._id === job.campus_id
								);
								const jobInst = props.institution;
								const classData =
									props.classes.find(
										(theClass) => theClass._id === job.class_id
									) || {};
								const refId = getRefId(job);

								return (
									//   new job component goes here
									<div key={index} className='d-flex align-items-stretch'>
										<span ref={refs[refId]} className='job-list-ref' />
										<BookingCardCollege
											job={job}
											campus={jobCampus}
											inst={jobInst}
											classData={classData}
											minWidth
											key={index}
											cancelSingleDay={cancelSingleDay}
											confirmBookingCancel={confirmBookingCancel}
											confirmChangeLevel={confirmChangeLevel}
											isViewAsTeacher
											selectedDate={job.dates[dateIndex]}
											dateIndex={dateIndex}
											user={props.user}
											customer={props.user?.role === 'admin' ? props?.customer : null}
											qualifications={qualifications}
										/>
									</div>
								);
							})
						) : (
							'No results found.'
						)
					) : (
						<Spinner small />
					)}
				</div>

				{showCurrentBookings.length && isLoaded && !showSingleBooking ? (
					<div>
						<TablePagination
							component="div"
							count={paginationInfo?.total_record}
							page={paginationInfo.page - 1}
							onPageChange={(e, page) => onPageNumChange(e, page)}
							rowsPerPage={rowsPerPage}
							rowsPerPageOptions={[10, 25, 50]}
							size="large"
							onRowsPerPageChange={(e) => handleChangeRowsPerPage(e.target.value)}
							showFirstButton
							showLastButton
						/>
					</div>
          ) : null}
			</div>
			<JumpToTopButton />
		</div>
	);
}

export default CollegeJobListMain;
